import { RadioOption } from '../../../../../types/common';

// Photos / 3D-tour filters share the same tri-state shape.
// Any (either) is the default and omits the API param; Complete=true, None=false.
export const TRISTATE_EITHER = 'either';
export const TRISTATE_YES = 'yes';
export const TRISTATE_NO = 'no';

export const photosRadioOptions: RadioOption[] = [
  {
    label: 'Any',
    id: 'photos-either',
    value: TRISTATE_EITHER,
  },
  {
    label: 'Complete',
    id: 'photos-yes',
    value: TRISTATE_YES,
  },
  {
    label: 'None',
    id: 'photos-no',
    value: TRISTATE_NO,
  },
];

export const tourRadioOptions: RadioOption[] = [
  {
    label: 'Any',
    id: 'tour-either',
    value: TRISTATE_EITHER,
  },
  {
    label: 'Complete',
    id: 'tour-yes',
    value: TRISTATE_YES,
  },
  {
    label: 'None',
    id: 'tour-no',
    value: TRISTATE_NO,
  },
];

// Properties Displayed (active-status) filter. 'active' is the default
// and matches the previous header "Active Units" selection.
export const ACTIVE_STATUS_ACTIVE = 'active';
export const ACTIVE_STATUS_INACTIVE = 'inactive';
export const ACTIVE_STATUS_ALL = 'all';

export const activeStatusRadioOptions: RadioOption[] = [
  {
    label: 'Active',
    id: 'properties-displayed-active',
    value: ACTIVE_STATUS_ACTIVE,
  },
  {
    label: 'Inactive',
    id: 'properties-displayed-inactive',
    value: ACTIVE_STATUS_INACTIVE,
  },
  {
    label: 'All',
    id: 'properties-displayed-all',
    value: ACTIVE_STATUS_ALL,
  },
];

export const unableToCompleteRadioOptions: RadioOption[] = [
  {
    label: 'Yes',
    id: 'utc-yes',
    value: 'Yes',
  },
  {
    label: 'No',
    id: 'utc-no',
    value: 'No',
  },
];
